import React from 'react';
import { usePatientTreatmentContext } from './ContextProvider';
import PatientTreatmentPageWrapper from './PatientTreatmentPageWrapper';
import ECardWrapper from '../../../Ecard/Components/ECardWrapper/ECardWrapper';
import { ECardType } from '../../../Ecard/Enums/ECardType.enum';
import { HealthDocumentationFileRef } from '../../../Ecard/Interfaces/HealthDocumentationFileRef.interface';

interface PatientTreatmentDocumentationProps {
	type: ECardType;
	patientsOriginalId?: string;
	/** Health documentation: sends the selected files elsewhere (a new Dočasné úložiště package). */
	onSendFiles?: (files: HealthDocumentationFileRef[]) => void;
}

const PatientTreatmentDocumentation: React.FC<
	PatientTreatmentDocumentationProps
> = ({ type, patientsOriginalId, onSendFiles }) => {
	const { patientId } = usePatientTreatmentContext();

	return (
		<>
			<PatientTreatmentPageWrapper patientId={patientId}>
				<ECardWrapper
					type={type}
					patientId={patientId}
					patientsOriginalId={patientsOriginalId}
					onSendFiles={onSendFiles}
				/>
			</PatientTreatmentPageWrapper>
		</>
	);
};

export default PatientTreatmentDocumentation;
